import { render } from "./Message.vue?vue&type=template&id=02d5564d"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"
script.render = render

export default script